module.exports = __webpack_public_path__ + "static/media/back.858211f3.svg";